import { Controller } from "@hotwired/stimulus"
import * as React from "react"
import * as ReactDOM from "react-dom"
import { PaintbrushColorPicker } from "../paintbrush/paintbrush_color_picker"

function normalizeColor(raw: string): string {
  let color = raw || "#000000"
  if (!color.startsWith("#")) {
    color = `#${color}`
  }
  return color.toUpperCase()
}

type CategoryColorFieldProps = {
  initialColor: string
  input: HTMLInputElement
}

const CategoryColorField: React.FC<CategoryColorFieldProps> = ({ initialColor, input }) => {
  const [color, setColor] = React.useState(() => normalizeColor(initialColor))

  return (
    <PaintbrushColorPicker
      color={color}
      size={28}
      title="Default map colour"
      placement="right"
      onChange={next => {
        const normalized = normalizeColor(next)
        setColor(normalized)
        input.value = normalized
      }}
    />
  )
}

export default class extends Controller {
  static targets = ["mount", "input"]
  static values = { color: String }

  declare readonly mountTarget: HTMLElement
  declare readonly inputTarget: HTMLInputElement
  declare colorValue: string

  connect() {
    ReactDOM.render(
      <CategoryColorField
        initialColor={normalizeColor(this.colorValue || this.inputTarget.value)}
        input={this.inputTarget}
      />,
      this.mountTarget,
    )
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.mountTarget)
  }
}
